module.exports = __webpack_public_path__ + "img/clearscore.c8dbae7e.png";